import * as constants from './constants';
import {
  fromJS
} from 'immutable';
const defaultState =  fromJS({
    info: [],
    infoList: [],
    topicList:[],
    topicChatList:[],
    attachmentList:[],
    topicId:'',
    newAddTopicData:{}, 
    collect:false,

})

export default (state = defaultState, action) => {
    switch (action.type) {
        case constants.CHANGE_COURSELIVE_DATA:
            return state.merge({
                info:action.info
            }); 
        case constants.CHANGE_COURSELIVE_LIST_DATA:
            return state.merge({
                infoList:state.get('infoList').concat(action.infoList)
            });
        case constants.CHANGE_TOPIC_LIST:
            return state.merge({
                topicList:action.topicList
            });
        case constants.CHANGE_TOPIC_CHAT_LIST:
            return state.merge({
                topicChatList:action.topicChatList
            });
        case constants.CHANGE_ATTACHMENT_LIST:
            return state.merge({
                attachmentList:action.attachmentList
            });
        case constants.CHANGE_TOPIC_ID:
            return state.merge({
                topicId:action.topicId
            });
        case constants.CHANGE_TOPIC_NEW_DATA:
            return state.merge({
                newAddTopicData:action.newAddTopicData
            });
        case constants.CHANGE_COLLECT:
            return state.merge({
                collect:action.collect
            })
        default:
            return state;
    }
}
 